/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Bad_RequestInputs */

const es_co2_error_bad_request = /** @type {(inputs: Error_Bad_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La solicitud no es válida. Revisa los datos e intenta de nuevo.`)
};

/**

* @param {Error_Bad_RequestInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_bad_request = /** @type {((inputs?: Error_Bad_RequestInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Bad_RequestInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_bad_request(inputs)
});